// Author thq
// Date 2024-03-30 10:36:37

class TpmAxisCoordinateDataAcd {
constructor({
        id = null,
        acdDeviceCode = '',
        acdDeviceSystemType = '',
        acdCollectTime = '',
        acdOperatorId = '',
        acdOperatorName = '',
        acdDeptName = '',
        acdProjectCode = '',
        acdItemName = '',
        acdOrderCode = '',
        acdOperationSeq = '',
        acdOperationName = '',
        acdLocationId = '',
        acdLocationName = '',
        acdGeometricX = '',
        acdGeometricY = '',
        acdGeometricZ = '',
        acdGeometricA = '',
        acdGeometricB = '',
        acdGeometricC = '',
        acdGeometricV = '',
        acdGeometricW = '',
        acdGeometricSP = '',
        acdMachineX = '',
        acdMachineY = '',
        acdMachineZ = '',
        acdMachineA = '',
        acdMachineB = '',
        acdMachineC = '',
        acdMachineV = '',
        acdMachineW = '',
        acdMachineSP = '',
        acdLoadX = '',
        acdLoadY = '',
        acdLoadZ = '',
        acdLoadA = '',
        acdLoadB = '',
        acdLoadC = '',
        acdLoadV = '',
        acdLoadW = '',
        remark = ''}
= {}) {
    this.id = id;
    this.acdDeviceCode = acdDeviceCode;
    this.acdDeviceSystemType = acdDeviceSystemType;
    this.acdCollectTime = acdCollectTime;
    this.acdOperatorId = acdOperatorId;
    this.acdOperatorName = acdOperatorName;
    this.acdDeptName = acdDeptName;
    this.acdProjectCode = acdProjectCode;
    this.acdItemName = acdItemName;
    this.acdOrderCode = acdOrderCode;
    this.acdOperationSeq = acdOperationSeq;
    this.acdOperationName = acdOperationName;
    this.acdLocationId = acdLocationId;
    this.acdLocationName = acdLocationName;
    this.acdGeometricX = acdGeometricX;
    this.acdGeometricY = acdGeometricY;
    this.acdGeometricZ = acdGeometricZ;
    this.acdGeometricA = acdGeometricA;
    this.acdGeometricB = acdGeometricB;
    this.acdGeometricC = acdGeometricC;
    this.acdGeometricV = acdGeometricV;
    this.acdGeometricW = acdGeometricW;
    this.acdGeometricSP = acdGeometricSP;
    this.acdMachineX = acdMachineX;
    this.acdMachineY = acdMachineY;
    this.acdMachineZ = acdMachineZ;
    this.acdMachineA = acdMachineA;
    this.acdMachineB = acdMachineB;
    this.acdMachineC = acdMachineC;
    this.acdMachineV = acdMachineV;
    this.acdMachineW = acdMachineW;
    this.acdMachineSP = acdMachineSP;
    this.acdLoadX = acdLoadX;
    this.acdLoadY = acdLoadY;
    this.acdLoadZ = acdLoadZ;
    this.acdLoadA = acdLoadA;
    this.acdLoadB = acdLoadB;
    this.acdLoadC = acdLoadC;
    this.acdLoadV = acdLoadV;
    this.acdLoadW = acdLoadW;
    this.remark = remark;
}
}

function newEntity() {
return new TpmAxisCoordinateDataAcd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdDeviceCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdDeviceSystemType',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdDeviceSystemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdCollectTime',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdCollectTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdOperatorId',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdOperatorId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdOperatorName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdOperatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdDeptName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdProjectCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdItemName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdItemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdOrderCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdOperationSeq',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdOperationSeq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdOperationName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdOperationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLocationId',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLocationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLocationName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLocationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricA',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricB',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricB',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricC',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricV',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricV',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdGeometricW',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdGeometricW',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineA',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineB',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineB',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineC',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineV',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineV',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdMachineW',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdMachineW',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadB',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadB',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadC',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadV',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadV',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'acdLoadW',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.acdLoadW',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    acdDeviceCodeFilter : '',
    acdDeviceSystemTypeFilter : '',
    acdCollectTimeRteFilter : '',
    acdCollectTimeLteFilter : '',
    acdOperatorIdFilter : '',
    acdOperatorNameFilter : '',
    acdDeptNameFilter : '',
    acdProjectCodeFilter : '',
    acdItemNameFilter : '',
    acdOrderCodeFilter : '',
    acdOperationSeqFilter : '',
    acdOperationNameFilter : '',
    acdLocationIdFilter : '',
    acdLocationNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'acdDeviceCodeFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdDeviceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdDeviceSystemTypeFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdDeviceSystemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdCollectTimeRteFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdCollectTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdCollectTimeLteFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdCollectTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOperatorNameFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdOperatorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdDeptNameFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdDeptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdProjectCodeFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdItemNameFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdItemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOrderCodeFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOperationNameFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdOperationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLocationNameFilter',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.filter.acdLocationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'acdDeviceCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdDeviceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"acdDeviceSystemType":"bdaExtendedFieldsA"}'
                }
        },
        {
        key: 'acdDeviceSystemType',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdCollectTime',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdCollectTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOperatorName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdOperatorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"acdOperatorId":"id"}'
                }
        },
        {
        key: 'acdDeptName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdDeptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdProjectCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdItemName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdItemName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOrderCode',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdOrderCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOperationSeq',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdOperationSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdOperationName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdOperationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLocationId',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLocationName',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdGeometricX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdGeometricX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdGeometricY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdGeometricY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdGeometricZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdGeometricZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdGeometricA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdGeometricA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdGeometricC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdGeometricC',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdMachineX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdMachineX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdMachineY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdMachineY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdMachineZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdMachineZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdMachineA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdMachineA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdMachineC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdMachineC',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLoadX',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLoadX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLoadY',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLoadY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLoadZ',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLoadZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLoadA',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLoadA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'acdLoadC',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.acdLoadC',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.tpmAxisCoordinateDataAcd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {TpmAxisCoordinateDataAcd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
